var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-input-header"},[_c('img',{staticStyle:{"height":"110px","margin-top":"-20px","margin-bottom":"-20px"},attrs:{"src":require("../assets/header.png")}})])
}]

export { render, staticRenderFns }